// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1cvKT","header":"PatientQuestionnaire_header__2xQas","info":"PatientQuestionnaire_info__3n_st"};